<template>
  <!-- 在线月度分析报告 -->
  <div class="analysisReport" style="overflow: hidden;">
    <div class="bgc">
      <!-- <div></div> -->
      <div class="bgcText">
        <h1>职业教育“{{header.zykName}}”专业大数据月度分析报告</h1>
        <!-- <h1 style="margin-top: 200px;"></h1> -->
        <!-- <h1>职业教育“{{header.zykName}}”专业大教学资源库（{{header.zykNum}}）</h1> -->
        <h2>（{{titleYear}}年{{monthly}}月）</h2>
      </div>
      <p></p>
    </div>

    <div class="analysisReport_box" id="pdfPrint">
      <div style="height: 2350px;">
        <div class="header_titles">
          <div class="division" style="margin:50px 0px">
            <span>1. 专业基本信息</span>
          </div>

          <div class="chart_box">
            <div class="lineheight" style="text-align: left;">
              <!-- :style="{width:this.list.length>=1?((this.list[0].td1.length-1)*200+130)+'px':'600px'}" -->
              <div class="table_box">
                <div class="table">
                  <template v-for="(item) in list">
                    <div class="tr">
                      <div class="td" v-for="(td,index1) in item.td1" :key="index1">{{td}}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="division">
        <span>2. 本专业国家级资源库（{{this.$route.query.zykNum}}）运行数据分析</span>
      </div>
      <div class="number_time2" style="margin-top: 30px;">
        <div>
          <span class="shchool">主持院校：{{allHostUnit}}</span>
          <span class="time">时间：{{this.$route.query.startTime}} 至 {{this.$route.query.endTime}}</span>
        </div>
        <p></p>
        <p></p>
      </div>

      <div class="chart_box" style="margin-top:100px;">
        <div class="chart_box">
          <h3>2.1 当前资源库总体情况</h3>
          <div class="chart_box">
            <h4>2.1.1 当前资源库用户情况</h4>
            <p>
              当前该资源库的用户数{{dataHandler(resourceLibrary.total)}}人，其中学生{{dataHandler(resourceLibrary.studentNum)}}人；教师{{dataHandler(resourceLibrary.teacherNum)}}人；社会学习者{{dataHandler(resourceLibrary.socialNum)}}人；企业用户{{dataHandler(resourceLibrary.enterpriseNum)}}人。具体如图1所示。
            </p>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'resourceLibraryChart'" :isShowTextColor="true" :datas='resourceLibrary.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>
            <div class="chart_name">图1 资源库注册用户类型分布总体情况</div>
          </div>
          <div class="chart_box" style="margin-top: 75px">
            <h4>2.1.2 当前资源库建设单位注册用户情况</h4>
            <p>
              当前该资源库教师用户{{dataHandler(resourceLibrary.teacherNum)}}人，其中主持单位的教师用户{{dataHandler(userCountUnit.zcteacherNum)}}人，参建单位的教师用户{{dataHandler(userCountUnit.teacherNum)}}人；学生用户{{dataHandler(resourceLibrary.studentNum)}}人，其中主持单位的学生用户{{userCountUnit.zcstudentNum}}人，参建单位的学生用户{{dataHandler(userCountUnit.studentNum)}}人。具体如图2所示。
            </p>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'resourceLibraryChart'" :isShowTextColor="true" :datas='userCountUnit.teacherList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'resourceLibraryChart'" :isShowTextColor="true" :datas='userCountUnit.studentList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>

            <div class="chart_name">图2 当前资源库建设单位注册用户情况</div>
          </div>
          <div class="chart_box" style="margin-top: 600px;">
            <h4>2.1.3 当前资源库资源建设情况</h4>
            <p>
              当前该资源库的素材资源总数{{dataHandler(typeDistribution.total)}}个，其中文本类{{dataHandler(typeDistribution.wbNumber)}}个；图形图像类{{dataHandler(typeDistribution.txtxNumber)}}个；视频类{{dataHandler(typeDistribution.spNumber)}}个；动画类{{dataHandler(typeDistribution.dhNumber)}}个；虚拟仿真类{{dataHandler(typeDistribution.xnfzNumber)}}个；微课类{{dataHandler(typeDistribution.wkNumber)}}个；音频类{{dataHandler(typeDistribution.ypNumber)}}个；ppt和富媒体等{{dataHandler(typeDistribution.pptNumber+typeDistribution.kjNumber+typeDistribution.fmtNumber)}}个；其他{{dataHandler(typeDistribution.qtNumber)}}个。具体如图3所示。
            </p>
            <div class="standards_content echartsHeight">
              <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='typeDistribution.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'50%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>
            <div class="chart_name" style="margin-top: 10px;">图3 资源库素材资源类型分布</div>
          </div>
          <div class="chart_box">
            <h4>2.1.4 当前资源库标准化课程建设与应用情况</h4>
            <p> 当前该资源库建有标准化课程{{dataHandler(standardization.courseBzNum)}}门，按访问量排名前10名如图4所示。</p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart style="height:140%;" :refId="'standardizationChart'" :isExportTextColor=" true" :isShowTextColor="true" :datas='standardization.dataList' :transverseData='standardization.transverseData' :colorList='standardization.colorList' :seriesColor='true'>
              </tcolumnarChart>·
            </div>
            <div class="chart_name" style="margin-top: 140px;">图4 该资源库标准化课程访问量排名</div>
            <div class="notes">
              （注1：标准化课程指资源库建设团队按照《指南》要求建设和提供的，涵盖课程基本知识点和技能点，能够适应全国同类和相近专业在线教学基本需要的结构化课程。标准化课程的正确性、逻辑性、权威性由资源库建设团队保证。个性化课程指教师在使用资源库过程中，结合自身实际教学需要和学生特点，对标准化课程进行改造、补充、重构后形成的个性化课程。个性化课程的正确性、逻辑性由建课教师自行保障。注2：如标准化课程或个性化课程显示为0，表明该资源库在课程标注上不规范，需要在资源库运行平台中对课程分类重新标注。）
            </div>
          </div>
          <div class="chart_box" style="margin-top: 740px;">
            <h4>2.1.5 当前资源库用户行为类型分布</h4>
            <p>
              该资源库用户行为活动总量为{{dataHandler(behaviorTypes.total)}}次，其中课程模块{{dataHandler(behaviorTypes.courseModule)}}次，资源素材模块{{dataHandler(behaviorTypes.resourceModule)}}次，论坛模块{{dataHandler(behaviorTypes.forumModule)}}次，作业模块{{dataHandler(behaviorTypes.taskModule)}}次，考试模块{{dataHandler(behaviorTypes.examinationModule)}}次，其他模块{{dataHandler(behaviorTypes.otherModule)}}次。具体如图5所示。
            </p>
            <div class="standards_content echartsHeight">
              <circularChart :isShowTextColor="true" :refId="'behaviorTypesChart'" :datas='behaviorTypes.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>
            <div class="chart_name">图5 资源库用户行为类型分布</div>
          </div>
          <div class="chart_box" style="margin-top: 100px;">
            <h4>2.1.6 资源库无活动数据情况</h4>
            <p>
              该资源库实名教师总数{{dataHandler(resourcePool.realTeacher)}}人，其中无活动教师{{dataHandler(resourcePool.countTeacher)}}人；实名学生总数{{dataHandler(resourcePool.realStudent)}}人，其中无活动学生{{dataHandler(resourcePool.countStudent)}}人；资源总数{{dataHandler(typeDistribution.total)}}条，其中无访问资源{{dataHandler(resourcePool.countResource)}}条；请继续关注应用情况，监督其深入应用。具体如图6所示。
            </p>
            <div class="speed">
              <el-row>
                <el-col :span="8">
                  <div class="right">实名教师中无活动教师占比:</div>
                </el-col>
                <el-col :span="16">
                  <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.teacher" color="#3B86FF"></el-progress>
                </el-col>

                <el-col :span="8">
                  <div class="right">实名学生中无活动学生占比:</div>
                </el-col>
                <el-col :span="16">
                  <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.student" color="#63D0FF"></el-progress>
                </el-col>

                <el-col :span="8">
                  <div class="right">无访问资源占比:</div>
                </el-col>
                <el-col :span="16">
                  <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.resource" color="#BBA8FF"></el-progress>
                </el-col>
              </el-row>
            </div>
            <div class="chart_name">图6 资源库无活动数据情况</div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 145px">
          <h3>2.2 本月资源库新增情况</h3>
          <div class="chart_box">
            <h4>2.2.1 本月用户新增情况</h4>
            <div class="chart_box">
              <p> 该资源库本月新增教师用户数{{dataHandler(usersMonth.teacherNum)}}人，新增学生用户数{{dataHandler(usersMonth.studentNum)}}人，新增企业用户数{{dataHandler(usersMonth.enterpriseNum)}}人，新增社会学习者用户数{{dataHandler(usersMonth.socialNum)}}人，新增其他用户数{{dataHandler(usersMonth.otherNum)}}人。具体如图7所示。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='usersMonth.dataList' :transverseData='usersMonth.transverseData' :colorList='usersMonth.colorList' :legendList="usersMonth.legendList" :innerText="'单位：人'"></discountChart>
              </div>
              <div class="chart_name">图7 本月用户新增情况</div>
            </div>

            <div class="chart_box" style="margin-top: 520px">
              <p>
                该资源库本月新增用户中，主持院校新增教师数{{majorUser.teacher}}人，参建院校新增教师数{{majorUser.cjteacher}}人，主持院校新增学生数{{majorUser.student}}人，参建院校新增学生数{{majorUser.cjstudent}}人，主持院校与参建院校新增占比情况。具体如下图8所示。
              </p>
              <div class="speed">
                <el-row>
                  <el-col :span="6">
                    <div style="font-size: 29px;">主持院校新增教师占比:</div>
                  </el-col>
                  <el-col :span="18">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.majorteacher" color="#3B86FF"></el-progress>
                  </el-col>

                  <el-col :span="6">
                    <div style="font-size: 29px;">参建院校新增教师占比：</div>
                  </el-col>
                  <el-col :span="18">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.unitteacher" color="#63D0FF"></el-progress>
                  </el-col>

                  <el-col :span="6">
                    <div style="font-size: 29px;">主持院校新增学生占比：</div>
                  </el-col>
                  <el-col :span="18">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.majorstudent" color="#BBA8FF"></el-progress>
                  </el-col>

                  <el-col :span="6">
                    <div style="font-size: 29px;">参建院校学生新增占比：</div>
                  </el-col>
                  <el-col :span="18">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.unitstudent" color="#7F88FE"></el-progress>
                  </el-col>
                </el-row>
              </div>
              <div class="chart_name">图8 主持院校与参建院校新增用户占比情况</div>
            </div>

            <div class="chart_box" style="margin-top: 100px">
              <p>
                该资源库本月实名教师中无活动教师{{dataHandler(resourcePool.countTeacher)}}人，占教师总数{{parseFloat(((resourcePool.countTeacher/resourceLibrary.teacherNum)*100).toFixed(2))}}%，实名学生中无活动学生{{dataHandler(resourcePool.countStudent)}}人，占学生总数{{parseFloat(((resourcePool.countStudent/resourceLibrary.studentNum)*100).toFixed(2))}}%。如下图9所示。
              </p>
              <div class="standards_content echartsHeight">
                <vcolumnarChart :refId="'verticalBarChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='verticalBar.dataList' :transverseData='verticalBar.transverseData' :colorList='verticalBar.colorList' :legendList="verticalBar.legendList" :seriesColor='true' :innerText="'单位：人'" :nameGap="10"></vcolumnarChart>
              </div>
              <div class="chart_name" style="margin-top: 10px;">图9 资源库无活动师生数据变化情况</div>
            </div>
          </div>

          <div class="chart_box" style="margin-top: 100px">
            <div class="chart_box">
              <h4>2.2.2 本月素材资源新增情况</h4>
              <p> 该资源库本月新增素材资源{{dataHandler(resourcesMonth.total)}}条。具体如图10所示。</p>
              <div class="standards_content echartsHeight">
                <circularChart :isShowTextColor="true" :refId="'resourcesMonthChart'" :datas='resourcesMonth.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
              </div>
              <div class="chart_name">图10 资源库各类型素材资源新增情况</div>
            </div>

            <div class="chart_box" style="margin-top: 50px">
              <h4></h4>
              <p>
                该资源库本月无访问资源数{{dataHandler(Andlastresource.noAccessResource)}}条，无访问资源数占总素材资源数{{Math.round(((resourcePool.countResource/typeDistribution.total)*100)).toFixed(2)}}%，较上月<span v-if="Andlastresource.noAccessResource - Andlastresource.lastMonthNoAccessResource < 0">减少{{Math.abs(Andlastresource.noAccessResource-Andlastresource.lastMonthNoAccessResource)}}</span>
                <span v-else-if="Andlastresource.noAccessResource - Andlastresource.lastMonthNoAccessResource == 0">减少0</span><span v-else>增加{{dataHandler(Math.abs(Andlastresource.noAccessResource - Andlastresource.lastMonthNoAccessResource))}}</span>条。具体如图11所示。
              </p>
              <div class="speed" ref="picture11">
                <el-row>
                  <el-col :span="5">
                    <div style="font-size: 28px;">上月无访问资源占比: </div>
                  </el-col>
                  <el-col :span="19">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.lastresource" color="#3B86FF"></el-progress>
                  </el-col>

                  <el-col :span="5">
                    <div style="font-size: 28px;">本月无访问资源占比: </div>
                  </el-col>
                  <el-col :span="19">
                    <el-progress :text-inside="true" :stroke-width="40" :percentage="waterDrop.resource" color="#63D0FF"></el-progress>
                  </el-col>
                </el-row>
              </div>
              <div class="chart_name divorced">图11 资源库无访问资源变化情况</div>
            </div>
          </div>

          <div class="chart_box" style="margin-top: 400px">
            <h4>2.2.3 本月课程新增情况</h4>
            <p>本月度标准化课程新增{{coursesMonth.standardNum}}门，个性化课程新增{{coursesMonth.personalityNum}}门。具体如图12所示。</p>
            <div class="standards_content echartsHeight">
              <circularChart :isShowTextColor="true" :refId="'lastcoursesMonthChart'" :datas='coursesMonth.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
            </div>
            <div class="chart_name divorced">图12 课程新增变化情况</div>
          </div>
        </div>

        <div class="chart_box">
          <h3>2.3 本月资源库应用情况</h3>
          <div class="chart_box">
            <div class="chart_box">
              <h4>2.3.1 本月资源访问情况</h4>
              <p> 该资源库本月资源访问数{{dataHandler(accessMonth.total)}}次。具体如图13所示。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'accessMonthChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='accessMonth.dataList' :transverseData='accessMonth.transverseData' :colorList='accessMonth.colorList' :legendList="accessMonth.legendList" :innerText="'单位：次'"></discountChart>
              </div>
              <div class="chart_name" style="margin-top: 10px;">图13 本月资源访问情况</div>
            </div>

            <div class="chart_box" style="margin-top: 200px">
              <h4>2.3.2 本月课程访问情况</h4>
              <p> 该资源库本月课程访问数{{dataHandler(visitsMonth.total)}}次。具体如图14所示。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'visitsMonthChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='visitsMonth.dataList' :transverseData='visitsMonth.transverseData' :colorList='visitsMonth.colorList' :legendList="visitsMonth.legendList" :innerText="'单位：次'"></discountChart>
              </div>
              <div class="chart_name" style="margin-top: 10px;">图14 本月课程访问情况</div>
            </div>

            <div class="chart_box" style="margin-top: 600px">
              <h4>2.3.3 本月用户访问情况</h4>
              <p> 该资源库本月用户访问数{{dataHandler(userAccessMonth.total)}}人次。具体访问趋势如图15所示。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'userAccessMonthChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='userAccessMonth.dataList' :transverseData='userAccessMonth.transverseData' :colorList='userAccessMonth.colorList' :legendList="userAccessMonth.legendList" :innerText="'单位：人次'"></discountChart>
              </div>
              <div class="chart_name" style="margin-top: 10px;">图15 本月用户访问情况</div>
            </div>

            <div class="chart_box" style="margin-top: 200px;">
              <p> 用户访问时间段分布。具体如图16所示。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'behaviorUserChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='behaviorUser.dataList' :transverseData='behaviorUser.transverseData' :colorList='behaviorUser.colorList' :legendList="behaviorUser.legendList" :innerText="'单位：人次'"></discountChart>
              </div>
              <div class="chart_name" style="margin-top: 10px;">图16 本月用户访问时间段分布</div>
            </div>
          </div>
        </div>
      </div>

      <div class="division" style="margin-top: 1150px;">
        <span>3. 本专业市场供需情况分析</span>
      </div>

      <div class="number_time2" style="margin-top: 30px;">
        <p></p>
        <p></p>
      </div>

      <div style="height: 2630px;">
        <div class="chart_box">
          <h4>3.1 本专业开设院校办学性质分布</h4>
          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 0 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 1 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 2 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 3 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}，{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}},具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}，{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}，{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 4 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}，{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}},{{getSchool.peopleten.name}}具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 5 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}、具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 6 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 7 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}，具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 8 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}},{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 9 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>

          <div>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 0">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；暂无民办院校排名。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 1">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名前一的省份为：{{getSchool.peopleFrist.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 2">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名前二的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}。具体如图17所示。
            </p>
            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 3">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 4">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 5">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 6">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 7">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 8">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 9">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}。具体如图17所示。
            </p>

            <p v-show="this.getSchool.publicSchoolRankArr.length == 10 && this.getSchool.privateSchoolRankArr.length == 10">
              在该时间段内系统统计显示，{{essential.majorName}}专业公办院校数量排名并列前三的省份为：{{getSchool.stateFrist.name}}、{{getSchool.stateSecond.name}}、{{getSchool.stateThird.name}}、{{getSchool.stateFourth.name}}、{{getSchool.statefive.name}}、{{getSchool.statesix.name}}、{{getSchool.stateseven.name}}、{{getSchool.stateeight.name}}、{{getSchool.statenine.name}}、{{getSchool.stateten.name}}；民办院校数量排名并列前三的省份为：{{getSchool.peopleFrist.name}}、{{getSchool.peopleSecond.name}}、{{getSchool.peopleThird.name}}、{{getSchool.peopleFourth.name}}、{{getSchool.peoplefive.name}}、{{getSchool.peoplesix.name}}、{{getSchool.peopleseven.name}}、{{getSchool.peopleeight.name}}、{{getSchool.peoplenine.name}}、{{getSchool.peopleten.name}}。具体如图17所示。
            </p>
          </div>
          <div class="standards_content echartsHeight">
            <stcolumnarChart style="height:140%;" :isShowTextColor="true" :refId="'lastcoursesMonthChart'" :legendList="getSchool.legendList" :datas='getSchool.dataList' :yAxisList='getSchool.transverseData' :colorList="getSchool.colorList" :innerText="'单位：门'"></stcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 170px;">图17 本专业开设院校办学性质分布</div>
        </div>

        <div class="chart_box" style="margin-top: 200px;">
          <h4>3.2 本专业开设院校地域分布</h4>
          <p>
            据{{titleYear}}年备案信息结果显示，{{essential.majorName}}专业开设点排名前五的城市有：{{map.Frist.name}}{{map.Frist.value}}个、{{map.Second.name}}{{map.Second.value}}个、{{map.Third.name}}{{map.Third.value}}个、{{map.Fourth.name}}{{map.Fourth.value}}个、{{map.fifth.name}}{{map.fifth.value}}个。具体如图18所示。
          </p>
          <div class=" standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='getSchoolRegion.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name">图18 本专业开设院校地域分布</div>
        </div>
      </div>

      <div style="height: 2200px;" v-if="essential.majorName == '应用电子技术' || essential.majorName == '助产' || essential.majorName == '道路养护与管理' || essential.majorName == '畜禽智能化养殖'|| essential.majorName == '药品生产技术' ">
        <div class="chart_box">
          <h4>3.3 全国区域专业开设点数分布</h4>
          <p>
            在该时间段内系统统计显示，全国区域{{essential.majorName}}专业岗位需求数量排名前五的城市有：{{map.Frist1.name}}{{map.Frist1.value}}个、{{map.Second1.name}}{{map.Second1.value}}个、{{map.Third1.name}}{{map.Third1.value}}个、{{map.Fourth1.name}}{{map.Fourth1.value}}个、{{map.fifth1.name}}{{map.fifth1.value}}个。具体如图19所示。
          </p>
          <div class="standards_content echartsHeight" style="height:780px">
            <hotMapChart :refId="'mapChart'" :datas='map.dataList' :legendList="map.legendList" :colorList="map.colorList" :nameColor="'black'" :Size="'20px'"></hotMapChart>
          </div>
          <div class="chart_name">图19 全国区域专业开设点数分布</div>
        </div>

        <div class="chart_box" style="margin-top: 200px;">
          <h4>3.4 本专业市场需求所属行业分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业可从事行业岗位招聘数量排名前三的分别为：{{distribution.Frist.name}}，{{distribution.Frist.value}}个岗位；{{distribution.Second.name}}，{{distribution.Second.value}}个岗位；{{distribution.Third.name}}，{{distribution.Third.value}}个岗位。具体如图20所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='distribution.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 5px;">图20 本专业市场需求所属行业分布</div>
        </div>
      </div>

      <div style="height: 2210px;" v-else>
        <div class="chart_box">
          <h4>3.3 全国区域专业开设点数分布</h4>
          <p>
            在该时间段内系统统计显示，全国区域{{essential.majorName}}专业岗位需求数量排名前五的城市有：{{map.Frist1.name}}{{map.Frist1.value}}个、{{map.Second1.name}}{{map.Second1.value}}个、{{map.Third1.name}}{{map.Third1.value}}个、{{map.Fourth1.name}}{{map.Fourth1.value}}个、{{map.fifth1.name}}{{map.fifth1.value}}个。具体如图19所示。
          </p>
          <div class="standards_content echartsHeight" style="height:780px">
            <hotMapChart :refId="'mapChart'" :datas='map.dataList' :legendList="map.legendList" :colorList="map.colorList" :nameColor="'black'" :Size="'20px'"></hotMapChart>
          </div>
          <div class="chart_name">图19 全国区域专业开设点数分布</div>
        </div>

        <div class="chart_box" style="margin-top: 200px;">
          <h4>3.4 本专业市场需求所属行业分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业可从事行业岗位招聘数量排名前三的分别为：{{distribution.Frist.name}}，{{distribution.Frist.value}}个岗位；{{distribution.Second.name}}，{{distribution.Second.value}}个岗位；{{distribution.Third.name}}，{{distribution.Third.value}}个岗位。具体如图20所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='distribution.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name" style="margin-top: 5px;">图20 本专业市场需求所属行业分布</div>
        </div>
      </div>

      <div style="height: 2705px;" v-if="essential.majorName == '应用电子技术' || essential.majorName == '助产' || essential.majorName == '道路养护与管理' || essential.majorName == '畜禽智能化养殖'|| essential.majorName == '药品生产技术' || essential.majorName == '现代物流管理'">
        <div class="chart_box" style="margin-top: 500px;">
          <h4>3.5 本专业市场需求地域分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业地区发布招聘岗位数量最多的为{{salaryposts.Frist.name}}地区，{{salaryposts.Frist.value}}个。具体如图21所示。
          </p>
          <div class="standards_content echartsHeight">
            <pieChart :refId="'universitiesChart'" :datas="salaryposts.dataList" :colorList="salaryposts.colorList" :nameColor="'black'"></pieChart>
          </div>
          <div class="chart_name">图21 本专业市场需求地域分布</div>
        </div>

        <div class="chart_box" style="margin-top: 100px;">
          <h4>3.6 本专业招聘单位类型分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业招聘单位分布排名前三的单位类型、数量情况：{{discipline.Frist.name}}{{discipline.Frist.value}}个；{{discipline.Second.name}}{{discipline.Second.value}}个；{{discipline.Third.name}}{{discipline.Third.value}}个。具体如图22所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='discipline.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name">图22 本专业招聘单位类型分布</div>
        </div>

        <div class="chart_box">
          <h4>3.7 本专业企业需求行业分布情况</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业可从事行业企业需求数量排名前三的分别为：{{getProfession.Frist.name}}，{{getProfession.Frist.num}}家；{{getProfession.Second.name}}，{{getProfession.Second.num}}家；{{getProfession.Third.name}}，{{getProfession.Third.num}}家。具体如图23所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart style="height:140%;" :refId="'rankingChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='getProfession.dataList' :transverseData='getProfession.transverseData' :colorList='getProfession.colorList' :gridY="'12%'"></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 150px;">图23 本专业企业需求行业分布情况</div>
        </div>
      </div>

      <div style="height: 2652px;" v-else>
        <div class="chart_box" style="margin-top: 500px;">
          <h4>3.5 本专业市场需求地域分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业地区发布招聘岗位数量最多的为{{salaryposts.Frist.name}}地区，{{salaryposts.Frist.value}}个。具体如图21所示。
          </p>
          <div class="standards_content echartsHeight">
            <pieChart :refId="'universitiesChart'" :datas="salaryposts.dataList" :colorList="salaryposts.colorList" :nameColor="'black'"></pieChart>
          </div>
          <div class="chart_name">图21 本专业市场需求地域分布</div>
        </div>

        <div class="chart_box" style="margin-top: 100px;">
          <h4>3.6 本专业招聘单位类型分布</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业招聘单位分布排名前三的单位类型、数量情况：{{discipline.Frist.name}}{{discipline.Frist.value}}个；{{discipline.Second.name}}{{discipline.Second.value}}个；{{discipline.Third.name}}{{discipline.Third.value}}个。具体如图22所示。
          </p>
          <div class="standards_content echartsHeight">
            <circularChart :isShowTextColor="true" :refId="'typeDistributionChart'" :datas='discipline.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'55%'" :circleSize="80" :legendListFontSize="30"></circularChart>
          </div>
          <div class="chart_name">图22 本专业招聘单位类型分布</div>
        </div>

        <div class="chart_box">
          <h4>3.7 本专业企业需求行业分布情况</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业可从事行业企业需求数量排名前三的分别为：{{getProfession.Frist.name}}，{{getProfession.Frist.num}}家；{{getProfession.Second.name}}，{{getProfession.Second.num}}家；{{getProfession.Third.name}}，{{getProfession.Third.num}}家。具体如图23所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart style="height:140%;" :refId="'rankingChart'" :isExportTextColor="true" :isShowTextColor="true" :datas='getProfession.dataList' :transverseData='getProfession.transverseData' :colorList='getProfession.colorList' :gridY="'12%'"></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 150px;">图23 本专业企业需求行业分布情况</div>
        </div>
      </div>

      <div style="height: 2650px;">
        <div class="chart_box" style="margin-top: 50px;">
          <h4>3.8 本专业面向职业需求排名</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业职业需求数量排名前三的职业有：{{ranking.Frist.name}}{{this.dataHandler(ranking.Frist.num)}}个、{{ranking.Second.name}}{{this.dataHandler(ranking.Second.num)}}个、{{ranking.Third.name}}{{this.dataHandler(ranking.Third.num)}}个。具体如图24所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart style="height:140%;" :isExportTextColor="true" :isShowTextColor="true" :refId="'rankingChart'" :datas='ranking.dataList' :transverseData='ranking.transverseData' :colorList='ranking.colorList' :gridY="'12%'" :gridHeight="'83%'"></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 150px;">图24 本专业面向职业需求排名</div>
        </div>

        <div class="chart_box">
          <h4>3.9 本专业面向职业薪酬排名</h4>
          <p>
            在该时间段内系统统计显示，{{essential.majorName}}专业职业薪酬排名前三的职业有：{{posts.Frist.name}}{{this.dataHandler(posts.Frist.num)}}元/月、{{posts.Second.name}}{{this.dataHandler(posts.Second.num)}}元/月、{{posts.Third.name}}{{this.dataHandler(posts.Third.num)}}元/月。具体如图25所示。
          </p>
          <div class="standards_content echartsHeight">
            <tcolumnarChart style="height:140%;" :isExportTextColor="true" :isShowTextColor="true" :refId="'rankingChart'" :datas='posts.dataList' :transverseData='posts.transverseData' :colorList='posts.colorList' :gridY="'5%'" :gridHeight="'83%'"></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 150px;">图25 本专业面向职业薪酬排名</div>
        </div>

        <div class="chart_box" style="margin-top: 40px">
          <h4>3.10 本专业面向职业发展方向分布</h4>
          <p v-show="getDevelopment.dataList.length >= 3">
            在该时间段内系统统计显示，{{essential.majorName}}职业发展方向岗位招聘数量排名前三的分别为：{{getDevelopment.Frist.name}}{{this.dataHandler(getDevelopment.Frist.value)}}个、{{getDevelopment.Second.name}}{{this.dataHandler(getDevelopment.Second.value)}}个，{{getDevelopment.Third.name}}{{this.dataHandler(getDevelopment.Third.value)}}个。具体如图26所示。
          </p>

          <p v-show="getDevelopment.dataList.length == 2">
            在该时间段内系统统计显示，{{essential.majorName}}职业发展方向岗位招聘数量排名前二的分别为：{{getDevelopment.Frist.name}}{{this.dataHandler(getDevelopment.Frist.value)}}个、{{getDevelopment.Second.name}}{{this.dataHandler(getDevelopment.Second.value)}}个。具体如图26所示。
          </p>

          <p v-show="getDevelopment.dataList.length == 1">
            在该时间段内系统统计显示，{{essential.majorName}}职业发展方向岗位招聘数量排名第一的为：{{getDevelopment.Frist.name}}{{this.dataHandler(getDevelopment.Frist.value)}}个。具体如图26所示。
          </p>

          <div class="standards_content echartsHeight">
            <pieChart :refId="'universitiesChart'" :datas="getDevelopment.dataList" :colorList="getDevelopment.colorList" :nameColor="'black'" :top="'10%'"></pieChart>
          </div>
          <div class="chart_name">图26 本专业面向职业发展方向分布</div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import circularChart from '@/components/chart/circularChart.vue' //引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue' //引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'; // 引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue' //引入折现图图表
import hotMapChart from '@/components/chart/hotMapChart.vue'    //专业就业地图
import stcolumnarChart from '@/components/chart/stcolumnarChart.vue'    //专业就业地图

import pieChart from '@/components/chart/pieChart.vue'    //专业就业地图

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    hotMapChart,
    stcolumnarChart,
    pieChart
  },
  data() {
    return {
      list: [{
        "td1": ["专业代码："],
      }, {
        "td1": ["专业名称："],
      }, {
        "td1": ["职业面向："],
      }, {
        "td1": ["培养目标定位："],
      }, {
        "td1": ["专业基础课程："],
      }, {
        "td1": ["专业核心课程："],
      }, {
        "td1": ["专业拓展课程："],
      }, {
        "td1": ["职业技能等级证书："],
      }, {
        "td1": ["接续高职本科："],
      }, {
        "td1": ["接续普通本科："],
      }],
      year: '',
      years: '',
      titleYear: '',
      monthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      allHostUnit: '',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],  //柱状图或折线图的颜色

      header: {
        zykName: '',
        zykNum: '',
        startTime: '',
        endTime: '',
        yearOrMonth: ''
      },
      essential: {

      },
      resourceLibrary: {  //图1 资源库注册用户类型分布总体情况
        dataList: [],
        total: 0,
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
      },
      userCountUnit: {  //图2 当前资源库参建单位注册用户情况
        teacherList: [],
        studentList: [],
        teacherNum: 0,
        studentNum: 0,
        zcteacherNum: 0,
        zcstudentNum: 0,
      },
      typeDistribution: {  //图3 资源库素材资源类型分布
        dataList: [],
        spNumber: 0,
        dhNumber: 0,
        txtxNumber: 0,
        xnfzNumber: 0,
        wbNumber: 0,
        wkNumber: 0,
        ypNumber: 0,
        kjNumber: 0,
        pptNumber: 0,
        fmtNumber: 0,
        qtNumber: 0,
        total: 0
      },
      standardization: {  //图4 该资源库标准化课程活跃用户排名
        dataList: [],
        transverseData: [],
        colorList: [],
        courseBzNum: 0
      },
      behaviorTypes: {   //图5 资源库用户行为类型分布
        dataList: [],
        total: 0,
        loginModule: 0,
        courseModule: 0,
        resourceModule: 0,
        forumModule: 0,
        taskModule: 0,
        examinationModule: 0,
        otherModule: 0
      },

      waterDrop: {
        teacher: 0,         //图6 资源库无活动数据情况
        student: 0,         //图6 资源库无活动数据情况
        resource: 0,        //图6 资源库无活动数据情况
        lastresource: 0,    //图11 资源库无访问资源较上月变化情况
        majorteacher: 0,    //图8 主持院校与参建院校新增占比情况
        majorstudent: 0,    //图8 主持院校与参建院校新增占比情况
        unitteacher: 0,     //图8 主持院校与参建院校新增占比情况
        unitstudent: 0      //图8 主持院校与参建院校新增占比情况
      },
      usersMonth: {  //图7 本月用户新增情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        teacherNum: 0,
        studentNum: 0,
        enterpriseNum: 0,
        socialNum: 0,
        otherNum: 0,
        total: 0
      },
      verticalBar: {   //图9 资源库无活动师生数据变化情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourcesMonth: {  //图10 资源库各类型素材资源新增情况
        dataList: [],
        total: 0
      },
      coursesMonth: {  //图12 本月课程新增情况
        dataList: [],
        total: 0,
        standardNum: 0,
        personalityNum: 0
      },
      accessMonth: {  //图13 本月资源访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      visitsMonth: {  //图14 本月课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      userAccessMonth: {  //图15 本月用户访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },
      behaviorUser: {  //图16 本月用户访问时间段分布
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0
      },

      resourcePool: {  //图6 资源库无活动数据情况,图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况
        countTeacher: 0,
        countStudent: 0,
        realTeacher: 0,
        realStudent: 0,
        countResource: 0
      },
      majorUser: {  //图8 主持院校与参建院校新增占比情况
        teacher: 0,
        student: 0,
        cjteacher: 0,
        cjstudent: 0
      },
      lastMonth: {  //图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况,图12 本月课程新增情况
        noAccessTeacher: 0,//无活动教师
        noAccessStudent: 0,//无活动学生
        noAccessResource: 0,//无活动资源
        videoNum: 0,
        animationNum: 0,
        graphicImageNum: 0,
        virtualSimulationNum: 0,
        textNum: 0,
        smallCourseNum: 0,
        shenyangNum: 0,
        coursewareNum: 0,
        pptNum: 0,
        mediaNum: 0,
        otherNum: 0,
        standardNum: 0,//标准化课程
        personalityNum: 0,//个性化课程
        resourceTotal: 0
      },
      Andlastresource: {
        noAccessResource: null,
        lastMonthNoAccessResource: null
      },

      map: {
        arr1: [],
        arr2: [],
        dataList: [],
        legendList: ['岗位需求数', '专业开设点数'],
        colorList: ['#40f1f6', '#fd891c'],
        Frist1: {},
        Second1: {},
        Third1: {},
        Fourth1: {},
        fifth1: {},
        Frist: {},
        Second: {},
        Third: {},
        Fourth: {},
        fifth: {}
      },
      getSchool: {
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: ['公办', '民办'],
        stateArr: [],
        peopleArr: [],
        publicSchoolRankArr: [],
        privateSchoolRankArr: [],
        // 公办
        stateFrist: {},
        stateSecond: {},
        stateThird: {},
        stateFourth: {},
        statefive: {},
        statesix: {},
        stateseven: {},
        stateeight: {},
        statenine: {},
        stateten: {},
        // 民办
        peopleFrist: {},
        peopleSecond: {},
        peopleThird: {},
        peopleFourth: {},
        peoplefive: {},
        peoplesix: {},
        peopleseven: {},
        peopleeight: {},
        peoplenine: {},
        peopleten: {},

        // 民办院校数组
        peopleArrNew: [],
        peopleFristNew: {},
        peopleSecondNew: {},
        peopleThirdNew: {},
        peoplefourthNew: {},
        peoplefifthNew: {},
        peoplesixthNew: {},

        Frist: {},
        Second: {},
        Third: {}
      },
      getSchoolRegion: {
        dataList: []
      },
      distribution: {  // 本专业岗位需求行业分布情况
        dataList: [],
        Frist: {},
        Second: {},
        Third: {}
      },

      //
      salaryposts: {
        dataList: [],
        colorList: ['#3B85FB', '#FD398E', '#04F995', '#E8FF6C', '#00EEF2', '#0DA1FD', '#F50512'],
        Frist: {}
      },
      discipline: {    //本专业招聘单位分布情况
        dataList: [],
        Frist: {},
        Second: {},
        Third: {}
      },
      getProfession: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        Third: {}
      },
      ranking: {    // 本专业岗位需求排名(15名)
        transverseData: [],
        dataList: [],
        colorList: [],
        Frist: {},
        Second: {},
        Third: {}
      },
      posts: {    // 本专业岗位薪酬排名
        transverseData: [],
        dataList: [],
        colorList: [],
        Frist: {},
        Second: {},
        Third: {}
      },
      // 本专业面向职业发展方向分布
      getDevelopment: {
        dataList: [],
        colorList: ['#3B85FB', '#FD398E', '#04F995', '#E8FF6C', '#00EEF2', '#0DA1FD', '#F50512'],
        Frist: {},
        Second: {},
        Third: {}
      },
      loading: '',    //是否导出加载中
    }
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      sessionStorage.setItem('lrmv2token', token)
      let zykid = this.$route.query.zykid;
      this.dataChange(zykid)
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName)
      var year = this.$route.query.yearOrMonth.substring(0, 4)
      var monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length)
      this.$route.query.startTime = year + '-' + monthly + '-' + '01'
      this.$route.query.endTime = year + '-' + monthly + '-' + new Date(year, monthly, 0).getDate()

      this.header = this.$route.query
      // 接口中传递的参数
      this.year = `${year}-${monthly}`
      // 图 9中的接口参数
      this.years = `${year}-${monthly}`

      this.titleYear = this.year.slice(0, 4)
      this.monthly = monthly
      this.yearMonthText = year + '年' + monthly + '月运行数据分析报告'
    }
    setTimeout(() => {
      this.getZykStatus()
      this.getZykInformationVo()
      this.essentialHandler()
      this.resourceLibraryDom()
      this.getUserCountUnitDom()
      this.typeDistributionDom()
      this.standardizationDom()
      this.behaviorTypesDom()
      this.resourcePoolDom()
      this.usersMonthDom()

      // this.getLrmv2MonthUserCourseResource()


      this.resourcesMonthDom()
      this.coursesMonthDom()
      this.accessMonthDom()
      this.visitsMonthDom()
      this.userAccessMonthDom()
      this.getLrmv2MonthBehaviorUserCourseLog()

      this.getSchoolHandler()   // 3.1
      this.getSchoolRegionHandler()

      // this.getCity()
      this.postsAcrossDom1()
      // this.postsAcrossDom2()
      this.distributionDom()    //   3.5
      this.salarypostsDom()     //   3.4
      this.disciplineDom()
      this.getProfessionHandler()
      this.rankingDom()
      this.postsDom()
      this.getDevelopmentHandler()
    }, 1000)
  },
  methods: {
    // 切换专业
    dataChange(e) {
      this.$axios.post(this.$apiurls.major_switch, e, {
        loading: false,
      }).then((res) => {
        if (res.data) {
          sessionStorage.setItem('zykId', e)
          this.reload();
        }
      });
    },
    reload() {  //切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$axios.post(this.$apiurls.exportMonthReport, {
        courseName: "",
        isAll: false,
        month: this.monthly,
        reportType: 0,
        zykId: sessionStorage.getItem('zykId'),
        zykName: this.header.zykName,
        zykNum: this.header.zykNum
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          window.open(res.data)
          this.loading.close();
        }
      }).catch(() => {
        this.loading.close();
      })
    },



    // 获取报告基本信息
    getZykInformationVo() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.header = res.data
          this.allHostUnit = res.data.allHostUnit.replaceAll(',', '，')
        }
      });
    },

    essentialHandler() {
      this.$axios.post(this.$apiurls.essential_getProfessionInfo, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data === null) {
            return
          } else {
            this.essential = res.data.data[0]

            this.list[0]["td1"].push(this.essential.majorCode);
            this.list[1]["td1"].push(this.essential.majorName);
            this.list[2]["td1"].push(this.essential.professionalFace);
            this.list[3]["td1"].push(this.essential.trainingObjectives);

            this.list[4]["td1"].push(this.essential.basicsCourse);
            this.list[5]["td1"].push(this.essential.coreCourse);
            this.list[6]["td1"].push(this.essential.internship);

            this.list[7]["td1"].push(this.essential.professionalLevelBook);
            this.list[8]["td1"].push(this.essential.highProfessionUndergraduate);
            this.list[9]["td1"].push(this.essential.ordinaryUndergraduate);

          }

        }
      });
    },

    //获取资源库状态
    getZykStatus() {
      this.$axios.post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem('zykId'), {
        loading: false,
      }).then((res) => {
        if (res) {
          this.zykStatus = res.data
        }
      });
    },

    // 图1 资源库注册用户类型分布总体情况
    resourceLibraryDom() {
      this.$axios.post(this.$apiurls.report_monthly_resourceLibrary, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          arrList.push({
            name: '教师',
            value: res.data.teacherNum
          }, {
            name: '学生',
            value: res.data.studentNum
          }, {
            name: '企业用户',
            value: res.data.enterpriseNum
          }, {
            name: '社会学习者',
            value: res.data.socialNum
          }, {
            name: '其他',
            value: res.data.otherNum
          }
          )
          this.resourceLibrary.total = res.data.totalNum
          this.resourceLibrary.teacherNum = res.data.teacherNum
          this.resourceLibrary.studentNum = res.data.studentNum
          this.resourceLibrary.enterpriseNum = res.data.enterpriseNum
          this.resourceLibrary.socialNum = res.data.socialNum
          // this.resourceLibrary.otherNum = res.data.otherNum
          this.resourceLibrary.dataList = arrList
        }
      });
    },
    //图2 当前资源库参建单位注册用户情况
    getUserCountUnitDom() {
      this.$axios.post(this.$apiurls.report_monthly_getUserCountUnit, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userCountUnit.teacherNum = res.data.teacherNum;
          this.userCountUnit.studentNum = res.data.studentNum;
          this.userCountUnit.zcteacherNum = res.data.enterpriseNum;
          this.userCountUnit.zcstudentNum = res.data.socialNum;
          var studentList = [];
          var teacherList = [];
          teacherList.push({
            name: '主持单位教师',
            value: res.data.enterpriseNum
          }, {
            name: '参建单位教师',
            value: res.data.teacherNum
          });

          studentList.push({
            name: '主持单位学生',
            value: res.data.socialNum
          }, {
            name: '参建单位学生',
            value: res.data.studentNum
          });
          this.userCountUnit.studentList = studentList;
          this.userCountUnit.teacherList = teacherList;
        }
      });
    },

    // 图3 资源库素材资源类型分布
    typeDistributionDom() {
      this.$axios.post(this.$apiurls.report_year_getStatResourceDataEntity, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          arrList.push({
            name: '视频类',
            value: res.data.videoNum
          }, {
            name: '动画类',
            value: res.data.animationNum
          }, {
            name: '图形图像类',
            value: res.data.graphicImageNum
          }, {
            name: '虚拟仿真类',
            value: res.data.virtualSimulationNum
          }, {
            name: '文本类',
            value: res.data.textNum
          }, {
            name: '微课类',
            value: res.data.smallCourseNum
          }, {
            name: '音频类',
            value: res.data.shenyangNum
          }, {
            name: 'ppt和富媒体等',
            value: res.data.pptNum + res.data.coursewareNum + res.data.mediaNum
          }, {
            name: '其他',
            value: res.data.otherNum
          })
          this.typeDistribution.spNumber = res.data.videoNum
          this.typeDistribution.dhNumber = res.data.animationNum
          this.typeDistribution.txtxNumber = res.data.graphicImageNum
          this.typeDistribution.xnfzNumber = res.data.virtualSimulationNum
          this.typeDistribution.wbNumber = res.data.textNum
          this.typeDistribution.wkNumber = res.data.smallCourseNum
          this.typeDistribution.ypNumber = res.data.shenyangNum
          this.typeDistribution.kjNumber = res.data.coursewareNum
          this.typeDistribution.pptNumber = res.data.pptNum
          this.typeDistribution.fmtNumber = res.data.mediaNum
          this.typeDistribution.qtNumber = res.data.otherNum
          this.typeDistribution.total = res.data.total
          this.typeDistribution.dataList = arrList
        }
      });
    },

    // 图4 该资源库标准化课程访问量排名
    standardizationDom() {
      this.$axios.post(this.$apiurls.report_monthly_standardization, {
        loading: false,
      }).then((res) => {
        if (res) {
          var name = []
          var value = []
          for (let i = 0; i < res.data.lrmv2UserResourceCourseRankingLogEntities.length; i++) {
            name.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].name)
            value.push(res.data.lrmv2UserResourceCourseRankingLogEntities[i].num)
          }
          this.standardization.dataList = value
          this.standardization.transverseData = name
          this.standardization.colorList = this.colorList
          this.standardization.courseBzNum = res.data.courseBzNum
        }
      });
    },

    // 图5 资源库用户行为类型分布
    behaviorTypesDom() {
      this.$axios.post(this.$apiurls.report_monthly_behaviorTypes, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          arrList.push({
            name: '课程模块',
            value: res.data.courseModule
          }, {
            name: '资源素材模块',
            value: res.data.resourceModule
          }, {
            name: '论坛模块',
            value: res.data.forumModule
          }, {
            name: '作业模块',
            value: res.data.taskModule
          }, {
            name: '考试模块',
            value: res.data.examinationModule
          }, {
            name: '其他模块',
            value: res.data.otherModule
          })
          this.behaviorTypes.loginModule = res.data.loginModule
          this.behaviorTypes.courseModule = res.data.courseModule
          this.behaviorTypes.resourceModule = res.data.resourceModule
          this.behaviorTypes.forumModule = res.data.forumModule
          this.behaviorTypes.taskModule = res.data.taskModule
          this.behaviorTypes.examinationModule = res.data.examinationModule
          this.behaviorTypes.otherModule = res.data.otherModule
          this.behaviorTypes.total = res.data.total
          this.behaviorTypes.dataList = arrList
        }
      });
    },
    // 图6 资源库无活动数据情况
    resourcePoolDom() {
      this.$axios.post(this.$apiurls.report_monthly_resourcePool, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourcePool = res.data
          this.waterDrop.teacher = Math.round(this.resourcePool.countTeacher / this.resourcePool.realTeacher * 100).toFixed(2)
          this.waterDrop.student = Math.round(this.resourcePool.countStudent / this.resourcePool.realStudent * 100).toFixed(2)
          this.waterDrop.resource = Math.round(this.resourcePool.countResource / this.typeDistribution.total * 100).toFixed(2)
          this.getLrmv2MonthUserCourseResource();
        }
      });
    },
    // 图7 本月用户新增情况
    usersMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 1, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var transverse = []
          var teacherNum = 0
          var studentNum = 0
          var enterpriseNum = 0
          var socialNum = 0
          var otherNum = 0
          for (let i = 0; i < res.data.teacher.length; i++) {
            transverse.push(i + 1)
            teacherNum += parseFloat(res.data.teacher[i])
          }
          for (let i = 0; i < res.data.student.length; i++) {
            studentNum += parseFloat(res.data.student[i])
          }
          for (let i = 0; i < res.data.enterprise.length; i++) {
            enterpriseNum += parseFloat(res.data.enterprise[i])
          }
          for (let i = 0; i < res.data.social.length; i++) {
            socialNum += parseFloat(res.data.social[i])
          }
          for (let i = 0; i < res.data.other.length; i++) {
            otherNum += parseFloat(res.data.other[i])
          }
          this.usersMonth.dataList = [res.data.teacher, res.data.student, res.data.enterprise, res.data.social, res.data.other]
          this.usersMonth.transverseData = transverse
          this.usersMonth.legendList = ['教师', '学生', '企业用户', '社会学习者', '其他']
          this.usersMonth.colorList = this.colorList
          this.usersMonth.teacherNum = teacherNum
          this.usersMonth.studentNum = studentNum
          this.usersMonth.enterpriseNum = enterpriseNum
          this.usersMonth.socialNum = socialNum
          this.usersMonth.otherNum = otherNum
          this.usersMonth.total = teacherNum + studentNum + enterpriseNum + socialNum + otherNum
          this.getMajorUser()

        }
      });
    },
    //图8 主持院校与参建院校新增占比情况
    getMajorUser() {
      this.$axios.post(this.$apiurls.report_monthly_getMajorUser, this.year, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.majorUser.teacher = res.data.teacher ? res.data.teacher : 0
          this.majorUser.student = res.data.student ? res.data.student : 0
          this.majorUser.cjteacher = res.data.cjteacher ? res.data.cjteacher : 0
          this.majorUser.cjstudent = res.data.cjstudent ? res.data.cjstudent : 0
          this.waterDrop.majorteacher = this.usersMonth.teacherNum ? Math.round(this.majorUser.teacher / this.usersMonth.teacherNum * 100).toFixed(2) : 0
          this.waterDrop.majorstudent = this.usersMonth.studentNum ? Math.round(this.majorUser.student / this.usersMonth.studentNum * 100).toFixed(2) : 0
          this.waterDrop.unitteacher = this.usersMonth.teacherNum ? Math.round(this.majorUser.cjteacher / this.usersMonth.teacherNum * 100).toFixed(2) : 0
          this.waterDrop.unitstudent = this.usersMonth.studentNum ? Math.round(this.majorUser.cjstudent / this.usersMonth.studentNum * 100).toFixed(2) : 0
        }
      });
    },
    // 图9 资源库无活动师生数据变化情况,图11 资源库无访问资源较上月变化情况,图12 本月课程新增情况
    getLrmv2MonthUserCourseResource() {
      this.$axios.post(this.$apiurls.report_monthly_getLrmv2MonthUserCourseResource, this.years, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.lastMonth = res.data
          this.verticalBar.dataList = [[this.lastMonth.noAccessTeacher, this.lastMonth.noAccessStudent], [this.resourcePool.countTeacher, this.resourcePool.countStudent]]
          this.verticalBar.transverseData = ['无活动教师', '无活动学生']
          this.verticalBar.colorList = this.colorList
          this.verticalBar.legendList = ['上月', '本月']
          this.Andlastresource.noAccessResource = res.data.noAccessResource
          this.Andlastresource.lastMonthNoAccessResource = res.data.lastMonthNoAccessResource
          this.waterDrop.lastresource = Math.round(this.Andlastresource.lastMonthNoAccessResource / this.typeDistribution.total * 100).toFixed(2)
          this.waterDrop.resource = Math.round(this.Andlastresource.noAccessResource / this.typeDistribution.total * 100).toFixed(2)
        }
      });
    },
    // 图10 资源库各类型素材资源新增情况
    resourcesMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 2, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          var number = 0
          var total = 0
          for (let i = 0; i < res.data.length; i++) {
            var detailed_type = "";
            switch (res.data[i].detailed_type) {
              case 1:
                detailed_type = "视频";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 2:
                detailed_type = "动画";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 3:
                detailed_type = "图形图像";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 4:
                detailed_type = "虚拟仿真";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 5:
                detailed_type = "文本";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 6:
                detailed_type = "微课";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 7:
                detailed_type = "音频";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
              case 8:

                number += res.data[i].num
                break;
              case 9:
                number += res.data[i].num
                break;
              case 10:
                number += res.data[i].num
                break;
              case 11:
                detailed_type = "其他";
                arrList.push({
                  name: detailed_type,
                  value: res.data[i].num
                })
                break;
            }
            total += parseFloat(res.data[i].num)
          }
          if (number > 0) {
            arrList.push({
              name: "ppt和富媒体等",
              value: number
            })
          }
          this.resourcesMonth.dataList = arrList
          this.resourcesMonth.total = total
        }
      });
    },
    // 图12 本月课程新增情况
    coursesMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 3, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.coursesMonth.dataList = []
          this.coursesMonth.dataList.push({
            name: '标准化课程',
            value: res.data.standardcCourse
          }, {
            name: '个性化课程',
            value: res.data.personalityCourse
          })
          this.coursesMonth.standardNum = res.data.standardcCourse
          this.coursesMonth.personalityNum = res.data.personalityCourse
        }
      });
    },
    // 图14 本月资源访问情况
    accessMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 4, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var transverse = []
          var total = 0
          for (let i = 0; i < res.data.reourceAccess.length; i++) {
            transverse.push(i + 1)
            total += parseFloat(res.data.reourceAccess[i])
          }
          this.accessMonth.dataList = res.data.reourceAccess
          this.accessMonth.transverseData = transverse
          this.accessMonth.legendList = ['资源访问']
          this.accessMonth.colorList = this.colorList
          this.accessMonth.total = total
        }
      });
    },
    // 图15 本月课程访问情况
    visitsMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 5, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var transverse = []
          var total = 0
          for (let i = 0; i < res.data.courseAccess.length; i++) {
            transverse.push(i + 1)
            total += parseFloat(res.data.courseAccess[i])
          }
          this.visitsMonth.dataList = res.data.courseAccess
          this.visitsMonth.transverseData = transverse
          this.visitsMonth.legendList = ['课程访问']
          this.visitsMonth.colorList = this.colorList
          this.visitsMonth.total = total
        }
      });
    },
    // 图16 本月用户访问情况
    userAccessMonthDom() {
      this.$axios.post(this.$apiurls.report_monthly_usersMonth, { type: 6, name: this.year }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var transverse = []
          var total = 0
          for (let i = 0; i < res.data.teacherAction.length; i++) {
            transverse.push(i + 1)
            total += parseFloat(res.data.teacherAction[i])
          }
          for (let i = 0; i < res.data.studentAction.length; i++) {
            total += parseFloat(res.data.studentAction[i])
          }
          for (let i = 0; i < res.data.enterpriseAction.length; i++) {
            total += parseFloat(res.data.enterpriseAction[i])
          }
          for (let i = 0; i < res.data.socialAction.length; i++) {
            total += parseFloat(res.data.socialAction[i])
          }
          this.userAccessMonth.dataList = [res.data.teacherAction, res.data.studentAction, res.data.enterpriseAction, res.data.socialAction]
          this.userAccessMonth.transverseData = transverse
          this.userAccessMonth.legendList = ['教师行为', '学生行为', '企业用户行为', '社会学习者行为']
          this.userAccessMonth.colorList = this.colorList
          this.userAccessMonth.total = total
        }
      });
    },
    // 图17 本月用户访问时间段分布
    getLrmv2MonthBehaviorUserCourseLog() {
      this.$axios.post(this.$apiurls.report_monthly_getLrmv2MonthBehaviorUserCourseLog, {
        loading: false,
      }).then((res) => {
        if (res) {
          var arrList = []
          var total = 0
          for (let i = 0; i < res.data.length; i++) {
            arrList.push([res.data[i].behaviorOne, res.data[i].behaviorTwo, res.data[i].behaviorThree, res.data[i].behaviorFour, res.data[i].behaviorFive, res.data[i].behaviorSix, res.data[i].behaviorSeven, res.data[i].behaviorEight])
            total += parseFloat(res.data[i].behaviorOne) + parseFloat(res.data[i].behaviorTwo) + parseFloat(res.data[i].behaviorThree) + parseFloat(res.data[i].behaviorFour) + parseFloat(res.data[i].behaviorFive) + parseFloat(res.data[i].behaviorSix) + parseFloat(res.data[i].behaviorSeven) + parseFloat(res.data[i].behaviorEight)
          }
          this.behaviorUser.dataList = arrList
          this.behaviorUser.transverseData = ['00：00—03：00', '03：00—06：00', '06：00—09：00', '09：00—12：00', '12：00—15：00', '15：00—18：00', '18：00—21：00', '21：00—00：00']
          this.behaviorUser.legendList = ['教师行为', '学生行为', '企业用户行为', '社会学习者行为']
          this.behaviorUser.colorList = this.colorList
          this.behaviorUser.total = total
        }
      });
    },
    // 3.1 本专业开设院校办学性质分布
    getSchoolHandler() {
      this.$axios.post(this.$apiurls.marketAnalysis_getSchoolNatureChart, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res.data) {


          // 公办院校
          for (let i = 0; i < res.data.data.value[0].length; i++) {
            this.getSchool.stateArr.push({ name: res.data.data.name[i], value: res.data.data.value[0][i] })
          }
          // 民办院校
          for (let i = 0; i < res.data.data.value[1].length; i++) {
            this.getSchool.peopleArr.push({ value: res.data.data.value[1][i], name: res.data.data.name[i] })
          }

          function Sort(a, b) {
            return b.value - a.value
          }

          // // 公办院校排序
          // this.getSchool.stateArr.sort(Sort)
          // // 当长度大于3的时候取第三名的数值为最大值，并且筛选过滤
          // if (this.getSchool.stateArr.length > 3) {
          //   // 设置一个最大值
          //   var Max = this.getSchool.stateArr[2].value - 0
          //   this.getSchool.publicSchoolRankArr = this.getSchool.stateArr.filter(item => item.value - 0 >= Max)

          // }

          // 民办院校排序
          this.getSchool.stateArr.sort(Sort)
          let newArr2 = this.getSchool.stateArr
          // 排除不等于 0  的数组
          this.getSchool.publicSchoolRankArr = newArr2.filter(item => item.value - 0 != 0)
          // 当长度大于3的时候取第三名的数值为最大值，并且筛选过滤
          if (this.getSchool.publicSchoolRankArr.length > 3) {
            // 设置一个最大值
            var Max = this.getSchool.publicSchoolRankArr[2].value - 0
            this.getSchool.publicSchoolRankArr = this.getSchool.publicSchoolRankArr.filter(item => item.value - 0 >= Max)
          }

          // // 当长度等于 3 得时候 ，说明数组中只有 3 个值
          // if (this.getSchool.stateArr.length == 3) {
          //   this.getSchool.stateArr.forEach((item, index) => {
          //     if (item.value - 0 != 0) {
          //       this.getSchool.publicSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.stateArr.slice(0, index)
          //     }
          //   })
          // }
          // // 当长度等于 2 得时候 ，说明数组中只有 2 个值
          // if (this.getSchool.stateArr.length == 2) {
          //   this.getSchool.stateArr.forEach((item, index) => {
          //     if (item.value - 0 != 0) {
          //       this.getSchool.publicSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.stateArr.slice(0, index)
          //     }
          //   })
          // }
          // // 当长度等于 2 得时候 ，说明数组中只有 2 个值
          // if (this.getSchool.stateArr.length == 1) {
          //   this.getSchool.stateArr.forEach((item, index) => {
          //     if (item.value != 0) {
          //       this.getSchool.publicSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.publicSchoolRankArr = []
          //     }
          //   })
          // }



          if (this.getSchool.publicSchoolRankArr.length == 0) {
            this.getSchool.stateFrist = []
          } else if (this.getSchool.publicSchoolRankArr.length == 1) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
          } else if (this.getSchool.publicSchoolRankArr.length == 2) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
          } else if (this.getSchool.publicSchoolRankArr.length == 3) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
          } else if (this.getSchool.publicSchoolRankArr.length == 4) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
          } else if (this.getSchool.publicSchoolRankArr.length == 5) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
          } else if (this.getSchool.publicSchoolRankArr.length == 6) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
            this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5]
          } else if (this.getSchool.publicSchoolRankArr.length == 7) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
            this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5]
            this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6]
          } else if (this.getSchool.publicSchoolRankArr.length == 8) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
            this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5]
            this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6]
            this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7]
          } else if (this.getSchool.publicSchoolRankArr.length == 9) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
            this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5]
            this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6]
            this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7]
            this.getSchool.statenine = this.getSchool.publicSchoolRankArr[8]
          } else if (this.getSchool.publicSchoolRankArr.length == 10) {
            this.getSchool.stateFrist = this.getSchool.publicSchoolRankArr[0]
            this.getSchool.stateSecond = this.getSchool.publicSchoolRankArr[1]
            this.getSchool.stateThird = this.getSchool.publicSchoolRankArr[2]
            this.getSchool.stateFourth = this.getSchool.publicSchoolRankArr[3]
            this.getSchool.statefive = this.getSchool.publicSchoolRankArr[4]
            this.getSchool.statesix = this.getSchool.publicSchoolRankArr[5]
            this.getSchool.stateseven = this.getSchool.publicSchoolRankArr[6]
            this.getSchool.stateeight = this.getSchool.publicSchoolRankArr[7]
            this.getSchool.statenine = this.getSchool.publicSchoolRankArr[8]
            this.getSchool.stateten = this.getSchool.publicSchoolRankArr[9]
          }



          // 民办院校排序
          this.getSchool.peopleArr.sort(Sort)
          let newArr1 = this.getSchool.peopleArr
          // 排除不等于 0  的数组
          this.getSchool.privateSchoolRankArr = newArr1.filter(item => item.value - 0 != 0)
          // 当长度大于3的时候取第三名的数值为最大值，并且筛选过滤
          if (this.getSchool.privateSchoolRankArr.length > 3) {
            // 设置一个最大值
            var Max = this.getSchool.privateSchoolRankArr[2].value - 0
            this.getSchool.privateSchoolRankArr = this.getSchool.privateSchoolRankArr.filter(item => item.value - 0 >= Max)
          }

          // // 当长度等于 3 得时候 ，说明数组中只有 3 个值
          // if (this.getSchool.privateSchoolRankArr.length == 3) {
          //   this.getSchool.privateSchoolRankArr.forEach((item, index) => {
          //     if (item.value - 0 != 0) {
          //       this.getSchool.privateSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.privateSchoolRankArr.slice(0, index)
          //     }
          //   })
          // }
          // // 当长度等于 2 得时候 ，说明数组中只有 2 个值
          // if (this.getSchool.privateSchoolRankArr.length == 2) {
          //   this.getSchool.privateSchoolRankArr.forEach((item, index) => {
          //     if (item.value - 0 != 0) {
          //       this.getSchool.privateSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.privateSchoolRankArr.slice(0, index)
          //     }
          //   })
          // }
          // // 当长度等于 2 得时候 ，说明数组中只有 2 个值
          // if (this.getSchool.privateSchoolRankArr.length == 1) {
          //   this.getSchool.privateSchoolRankArr.forEach((item, index) => {
          //     if (item.value != 0) {
          //       this.getSchool.privateSchoolRankArr.push(item)
          //     } else {
          //       this.getSchool.privateSchoolRankArr = []
          //     }
          //   })
          // }



          if (this.getSchool.privateSchoolRankArr.length == 0) {
            this.getSchool.peopleFrist = []
          } else if (this.getSchool.privateSchoolRankArr.length == 1) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
          } else if (this.getSchool.privateSchoolRankArr.length == 2) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
          } else if (this.getSchool.privateSchoolRankArr.length == 3) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
          } else if (this.getSchool.privateSchoolRankArr.length == 4) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
          } else if (this.getSchool.privateSchoolRankArr.length == 5) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
          } else if (this.getSchool.privateSchoolRankArr.length == 6) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
            this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5]
          } else if (this.getSchool.privateSchoolRankArr.length == 7) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
            this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5]
            this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6]
          } else if (this.getSchool.privateSchoolRankArr.length == 8) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
            this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[5]
            this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6]
            this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7]
          } else if (this.getSchool.privateSchoolRankArr.length == 9) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
            this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5]
            this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6]
            this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7]
            this.getSchool.peoplenine = this.getSchool.privateSchoolRankArr[8]
          } else if (this.getSchool.privateSchoolRankArr.length == 10) {
            this.getSchool.peopleFrist = this.getSchool.privateSchoolRankArr[0]
            this.getSchool.peopleSecond = this.getSchool.privateSchoolRankArr[1]
            this.getSchool.peopleThird = this.getSchool.privateSchoolRankArr[2]
            this.getSchool.peopleFourth = this.getSchool.privateSchoolRankArr[3]
            this.getSchool.peoplefive = this.getSchool.privateSchoolRankArr[4]
            this.getSchool.peoplesix = this.getSchool.privateSchoolRankArr[5]
            this.getSchool.peopleseven = this.getSchool.privateSchoolRankArr[6]
            this.getSchool.peopleeight = this.getSchool.privateSchoolRankArr[7]
            this.getSchool.peoplenine = this.getSchool.privateSchoolRankArr[8]
            this.getSchool.peopleten = this.getSchool.privateSchoolRankArr[9]
          }
          if (res) {
            this.getSchool.dataList = res.data.data.value
            this.getSchool.transverseData = res.data.data.name
            this.getSchool.colorList = this.colorList
          }
        }
      });
    },
    // 3.2 本专业开设院校地域分布
    getSchoolRegionHandler() {
      this.$axios.post(this.$apiurls.marketAnalysis_getSchoolRegion, {
        loading: false,
      }, { timeout: 3 * 60 * 1000 }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.data.name.length; i++) {
            this.getSchoolRegion.dataList.push({ name: res.data.data.name[i], value: res.data.data.value[i] })
          }
        }
      });
    },
    // 3.3 全国区域本专业岗位需求分布情况 地图
    postsAcrossDom1() {
      let p1 = new Promise((resolve, reject) => {
        this.$axios.post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 1, {
          loading: false,
        }).then((res) => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })

      let p2 = new Promise((resolve, reject) => {
        this.$axios.post(this.$apiurls.marketAnalysis_getCityPostOrSchoolNum, 2, {
          loading: false,
        }).then((res) => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })

      Promise.all([p1, p2]).then(res => {
        this.map.arr1.push(res[0].data)
        this.map.Frist1 = this.map.arr1[0][0]
        this.map.Second1 = this.map.arr1[0][1]
        this.map.Third1 = this.map.arr1[0][2]
        this.map.Fourth1 = this.map.arr1[0][3]
        this.map.fifth1 = this.map.arr1[0][4]

        this.map.arr2.push(res[1].data)
        this.map.Frist = this.map.arr2[0][0]
        this.map.Second = this.map.arr2[0][1]
        this.map.Third = this.map.arr2[0][2]
        this.map.Fourth = this.map.arr2[0][3]
        this.map.fifth = this.map.arr2[0][4]

        this.map.dataList.push(res[0].data, res[1].data)
      })
    },

    // 3.4 本专业岗位需求行业分布情况
    distributionDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getPostNum, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.distribution.dataList = res.data.data.map(item => {
            let name = item.name
            let value = item.num
            return {
              name,
              value
            }
          })
          this.distribution.Frist = this.distribution.dataList[0]
          this.distribution.Second = this.distribution.dataList[1]
          this.distribution.Third = this.distribution.dataList[2]
        }
      });
    },

    // 3.5 本专业市场需求地域分布
    salarypostsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getEnterpriseRegion, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.salaryposts.dataList.push({ name: item.name, value: item.num })
          })
          this.salaryposts.colorList = ['#3B86FF', '#5697FF', '#3FBBFE', '#66CAFE', '#7F88FE', '#BBA8FF', '#CACEFE', '#A3FFF8', '#63D0FF', '#82DAFF', '#4FC9FC', '#8EF1FF', '#6DD0D8', '#9FD5FF', '#79C6F8', '#31D8F8', '#11CBFF', '#6ACFFF', '#64BFFF', '#5093FF'];


          this.colorLoop(this.salaryposts.dataList, this.salaryposts.colorList)
          this.salaryposts.Frist = this.salaryposts.dataList[0]
        }
      });
    },

    disciplineDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionEnterpriseTypeNum, {
        loading: false,
      }).then((res) => {
        if (res.data) {
          if (res.data.length > 8) {
            this.discipline.isScroll = true
          } else {
            this.discipline.isScroll = false
          }
          this.discipline.height = 280
          this.discipline.dataList = res.data.data.list.map(item => {
            let name = item.name
            let value = item.num
            return {
              name,
              value
            }
          })
          function Sort(a, b) {
            return b.value - a.value
          }

          this.discipline.dataList.sort(Sort)
          this.discipline.Frist = this.discipline.dataList[0]
          this.discipline.Second = this.discipline.dataList[1]
          this.discipline.Third = this.discipline.dataList[2]

        } else {
          return
        }




      });
    },

    // 3.7 本专业企业需求行业分布情况
    getProfessionHandler() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionEnterpriseNum, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.getProfession.Frist = res.data.data[0]
          this.getProfession.Second = res.data.data[1]
          this.getProfession.Third = res.data.data[2]

          res.data.data.forEach(item => {
            this.getProfession.dataList.push(item.num)
            this.getProfession.transverseData.push(item.name)
          })
          this.getProfession.colorList = this.colorList
        }
      });
    },
    // 3.8 本专业岗位需求排名(15名)
    rankingDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionHotJob, 4, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.ranking.transverseData.push(item.name)
            this.ranking.dataList.push(item.num)
          })
          let datas = []
          res.data.data.list.forEach(item => {
            datas.push({ name: item.name, num: item.num })
          })
          this.ranking.colorList = this.colorList

          this.ranking.Frist = datas[0]
          this.ranking.Second = datas[1]
          this.ranking.Third = datas[2]
        }
      });
    },
    // 第二层
    // 3.9 本专业岗位薪酬排名
    postsDom() {
      this.$axios.post(this.$apiurls.marketAnalysis_getProfessionHotJob, 5, {
        loading: false,
      }).then((res) => {
        if (res) {
          res.data.data.list.forEach(item => {
            this.posts.transverseData.push(item.name)
            this.posts.dataList.push(item.num)
          })
          let datas = []
          res.data.data.list.forEach(item => {
            datas.push({ name: item.name, num: item.num })
          })
          this.posts.colorList = this.colorList

          this.posts.Frist = datas[0]
          this.posts.Second = datas[1]
          this.posts.Third = datas[2]
        }
      });
    },

    // 3.10 本专业面向职业发展方向分布
    getDevelopmentHandler() {

      this.$axios.post(this.$apiurls.marketAnalysis_getDevelopmentDirection, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.getDevelopment.dataList = res.data.data.map(item => {
            let name = item.name
            let value = item.value
            return {
              name,
              value
            }
          })
          if (this.getDevelopment.dataList.length > 2) {
            this.getDevelopment.Frist = this.getDevelopment.dataList[0]
            this.getDevelopment.Second = this.getDevelopment.dataList[1]
            this.getDevelopment.Third = this.getDevelopment.dataList[2]
          } else if (this.getDevelopment.dataList.length > 1) {
            this.getDevelopment.Frist = this.getDevelopment.dataList[0]
            this.getDevelopment.Second = this.getDevelopment.dataList[1]
          } else {
            this.getDevelopment.Frist = this.getDevelopment.dataList[0]
          }

          this.getDevelopment.colorList = ['#3B86FF', '#5697FF', '#3FBBFE', '#66CAFE', '#A3FFF8', '#63D0FF', '#82DAFF', '#4FC9FC', '#8EF1FF', '#9FD5FF', '#79C6F8', '#31D8F8', '#11CBFF', '#6ACFFF', '#9FD5FF', '#79C6F8', '#6DD0D8', '#64BFFF', '#5093FF'];


          this.colorLoop(this.getDevelopment.dataList, this.getDevelopment.colorList)

        }
      });
    },

    getCity() {
      this.postsAcrossDom1()
      this.postsAcrossDom2()
    },

    // 数据改变

    dataHandler(data) {
      return data > 100000000 ? (data / 100000000).toFixed(2) + '亿' : data > 10000 ? (data / 10000).toFixed(2) + '万' : data
    },
    setText() {
      return this.Andlastresource.noAccessResource
    },
    setText2() {
      return this.Andlastresource.lastMonthNoAccessResource
    },

    colorLoop(dataList, colorList) {
      let arrrList = []
      let i = 0
      colorList = colorList.reverse()
      dataList.forEach((item, index) => {
        if (index % colorList.length == 0) {
          i = 0
        } else {
          i++
        }
        arrrList.push(colorList[i])
      })
      return arrrList
    },
  }
}
</script>

<style scoped>
* {
  padding: 0px;
  margin: 0px;
}
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  width: 85%;
  margin: 0px auto;
  height: 29562px;
}

.analysisReport_box h2,
.analysisReport h2 {
  font-size: 55px;
  color: #fff;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 40px;
}

.header_titles h1,
.analysisReport_box h1,
.analysisReport h1 {
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
  line-height: 70px;
  /* margin-top: 50px; */
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
  position: relative;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 29px;
}

.bgc {
  position: relative;
  background: linear-gradient(
    rgba(63, 117, 203) 0%,
    rgba(74, 130, 205) 50%,
    rgba(91, 154, 225) 100%
  );
  height: 575px;
  text-align: center;
  align-items: center;
}
.bgc h2 {
  margin-top: 20px;
}
.bgc p {
  width: 100%;
  height: 10px;
  background: #fff;
  position: absolute;
  bottom: 20px;
  /* margin-top: 170px; */
}
.bgc .bgcText {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bgcText h1 {
  line-height: 90px;
  padding: 0px 20px;
  box-sizing: border-box;
}

.number_time2 {
  margin: 20px 0px;
}

.number_time2 div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 29px;
}

.number_time2 .shchool,
.number_time2 .time {
  font-size: 28px;
}

.number_time2 p {
  width: 100%;
  /* border-bottom: 4px; */
  height: 2px;
  background: rgba(0, 0, 255, 1);
  margin-top: 8px;
}
.number_time2 p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 60px;
}
.division span {
  margin: 0px auto;
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 55px;
  color: #1d244e;
}

.lineheight {
  position: relative;
}
.chart_box .lineheight p {
  line-height: 70px;
}
.chart_box .lineheight h6 {
  line-height: 35px;
}
.chart_box h3 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
  line-height: 40px;
  margin-bottom: 35px;
  margin-top: 50px;
}
.chart_box h4 {
  font-weight: 700;
  font-size: 40px;
  color: #1d244e;
  margin-bottom: 35px;
  margin-top: 50px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
  margin-bottom: 35px;
  margin-top: 50px;
}

.chart_box p {
  font-size: 35px;
  margin-bottom: 35px;
  text-indent: 2em;
  line-height: 70px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 90%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 28px;
  color: #000;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 50px;
  font-size: 30px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}

.lineheight .th_box .th {
  width: 350px;
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
  /* background: rgba(73, 187, 233); */
}

.left {
  float: left;
}
.rights {
  position: absolute;
  background: red;
  top: 0px;
  right: 0px;
}
.biaoge {
  height: auto;
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}
</style>


<style scoped>
.table_box {
  font-size: 35px;
  display: -webkit-box;
  width: 100%;
}

.table_box .table {
  margin: 0 auto;
}

.table_box .table .tr {
  display: flex;
  width: 100%;
}

.table_box .table .tr .td:nth-child(1) {
  width: 320px;
  line-height: 70px;
  text-align: right;
  /* border: 1px solid rgba(63, 63, 209); */
  /* border-right: 0px solid rgba(63, 63, 209); */

  /* margin: 1px 0px; */
  /* background: rgba(63, 63, 209); */
  color: black;
}

.table_box .table .tr .td:nth-child(2) {
  width: 1310px;
  line-height: 70px;
  color: #566178;
  /* border: 1px solid rgba(63, 63, 209); */
}
</style>
